"use strict";

var _classCallCheck = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/runner/work/website/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

exports.__esModule = true;
exports.default = exports.setAnalyticsEnabled = exports.isAnalyticsEnabled = void 0;

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _react = _interopRequireWildcard(require("react"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _reactRouterDom = require("react-router-dom");

var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\containers\\Analytics\\Analytics.js";

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var isAnalyticsEnabled = function isAnalyticsEnabled() {
  var enabled = localStorage.getItem('isAnalyticsEnabled');

  if (enabled === null) {
    enabled = null;
  } else {
    enabled = JSON.parse(enabled);
  }

  return enabled;
};

exports.isAnalyticsEnabled = isAnalyticsEnabled;

var setAnalyticsEnabled = function setAnalyticsEnabled(trackingID, enabled) {
  window["ga-disable-" + trackingID] = !enabled;
  localStorage.setItem('isAnalyticsEnabled', enabled);
};

exports.setAnalyticsEnabled = setAnalyticsEnabled;

var Analytics = /*#__PURE__*/function (_react$Component) {
  _inherits(Analytics, _react$Component);

  function Analytics() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Analytics);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Analytics)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isEnabled: false,
      showDialog: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "runAnalytics", function () {
      var _this$props = _this.props,
          history = _this$props.history,
          trackingID = _this$props.trackingID;

      _reactGa.default.initialize(trackingID, {
        anonymize_ip: true
      });

      _reactGa.default.pageview(window.location.pathname + window.location.search);

      history.listen(function (location) {
        _reactGa.default.set({
          page: location.pathname
        }); // Update the user's current page


        _reactGa.default.pageview(location.pathname); // Record a pageview for the given page

      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
      _this.setState({
        showDialog: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleAccept", function () {
      var trackingID = _this.props.trackingID;
      setAnalyticsEnabled(trackingID, true);

      _this.runAnalytics();

      _this.setState({
        showDialog: false,
        isEnabled: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePolicy", function () {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          policyPath = _this$props2.policyPath;
      history.push(policyPath);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDecline", function () {
      var trackingID = _this.props.trackingID;
      setAnalyticsEnabled(trackingID, false);

      _this.setState({
        showDialog: false,
        isEnabled: false
      });
    });

    return _this;
  }

  _createClass(Analytics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$isOptOut = this.props.isOptOut,
          isOptOut = _this$props$isOptOut === void 0 ? false : _this$props$isOptOut;
      var isEnabled = isAnalyticsEnabled(); //If analytics is enabled we run it

      if (isEnabled === true) {
        this.runAnalytics();
      } //We run analytics if we use opt-out and the analytics enabled is not set yet


      if (isEnabled === null && isOptOut) {
        this.runAnalytics();
      } //We show the analytics dialog if the analytics enabled flag is not set


      if (isEnabled === null) {
        this.setState({
          showDialog: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var showDialog = this.state.showDialog;
      var _this$props3 = this.props,
          renderDialog = _this$props3.renderDialog,
          handlePolicyClick = _this$props3.handlePolicyClick,
          _this$props3$acceptLa = _this$props3.acceptLabel,
          acceptLabel = _this$props3$acceptLa === void 0 ? 'Accept' : _this$props3$acceptLa,
          _this$props3$declineL = _this$props3.declineLabel,
          declineLabel = _this$props3$declineL === void 0 ? 'Decline' : _this$props3$declineL,
          _this$props3$policyLa = _this$props3.policyLabel,
          policyLabel = _this$props3$policyLa === void 0 ? 'Privacypolicy' : _this$props3$policyLa,
          _this$props3$dialogMe = _this$props3.dialogMessage,
          dialogMessage = _this$props3$dialogMe === void 0 ? 'This site uses cookies and website tracking technologies from third parties to offer and continuously improve their services. I consent to this and can revoke or change my consent at any time with future effect' : _this$props3$dialogMe;
      var Dialog = renderDialog;

      if (showDialog && renderDialog) {
        return /*#__PURE__*/_react.default.createElement(Dialog, _extends({
          showDialog: showDialog,
          handleAccept: this.handleAccept,
          handleClose: this.handleClose,
          handleDecline: this.handleDecline,
          handlePolicyClick: handlePolicyClick,
          dialogMessage: dialogMessage,
          policyLabel: policyLabel,
          declineLabel: declineLabel,
          acceptLabel: acceptLabel
        }, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 97,
            columnNumber: 9
          }
        }));
      }

      if (showDialog) {
        return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          open: showDialog,
          onClose: this.handleClose,
          message: dialogMessage,
          action: /*#__PURE__*/_react.default.createElement("div", {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 120,
              columnNumber: 13
            }
          }, handlePolicyClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
            color: "secondary",
            size: "small",
            onClick: handlePolicyClick,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128,
              columnNumber: 17
            }
          }, policyLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
            color: "primary",
            size: "small",
            onClick: this.handleDecline,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 136,
              columnNumber: 15
            }
          }, declineLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
            color: "inherit",
            size: "large",
            onClick: this.handleAccept,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 139,
              columnNumber: 15
            }
          }, acceptLabel)),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 9
          }
        });
      } else {
        return null;
      }
    }
  }]);

  return Analytics;
}(_react.Component);

var _default = (0, _reactRouterDom.withRouter)(Analytics);

exports.default = _default;